import { render, staticRenderFns } from "./PopupDeleteCompositeFolder.vue?vue&type=template&id=7a5d7c68"
import script from "./PopupDeleteCompositeFolder.vue?vue&type=script&lang=ts"
export * from "./PopupDeleteCompositeFolder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports